<template>
  <component :is="component" v-if="component" :entry="entry" :section-title="sectionTitle" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { componentForComplianceDataEntry } from './componentForEntry'

const props = defineProps<{ entry: { __typename: string } & any; sectionTitle?: string }>()
const component = computed(() => componentForComplianceDataEntry(props.entry.__typename as any))
</script>
